<div class="bulk-upload-model-view">
  <div class=" uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
    <div class="uitk-c-card uhc-font">
      <!-- <span class="bulk-note">Limit : 2000 rows. It is recommended to submit only records which have atleast one
      change and
    run bulk upload in non business hours if you are submitting more than 200 records</span> -->
      <div class="bulk-upload-model-view tile-card-structure capital-demand-bulk mt-2">
        <mat-tab-group [(selectedIndex)]="selectedIndex" (selectedTabChange)="tabChange($event)">
          <mat-tab label="OT Leader" #capitalDemandInvestment></mat-tab>
          @if (isFundingAdmin) {
          <mat-tab label="UCMG" #capitalDemandOwners></mat-tab>
          }
          <!-- <ng-container *ngIf="userWithAccess">
        <mat-tab label="Hierarchy Mismatch" #hierarchyMismatch></mat-tab>
        <mat-tab label="Bulk Edit" #bulkEdit></mat-tab>
      </ng-container> -->
        </mat-tab-group>

        <div>
          <div class="row m-0 mt-4">
            <div class="col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xs-4">
              <span class="form-inline-new">
                <p class="merge-headers" style="color: #013b71;font-weight: bold;">Step #1</p>
              </span>
              <span class="download-temaplte">
                <a [href]="Filepath" download>
                  Download Template
                </a>
                <a class="d-block mt-2 cursor-pointer" (click)="downloadOtData()">Download OT Dept Data</a>
              </span>
            </div>
            <div class="col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xs-4">
              <span class="form-inline-new">
                <p class="merge-headers" style="color: #013b71;font-weight: bold;">Step #2</p>
              </span>
              <span class="">
                Add your data (changes only) in the Template.
              </span>
            </div>
            <div class="col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xs-4">
              <span class="form-inline-new">
                <p class="merge-headers" style="color: #013b71;font-weight: bold;">Step #3</p>
              </span>
              <span class="">
                <input
                  type="file"
                  [disabled]="!validTime"
                  #fileInput
                  id="uploadFile"
                  (change)="uploadBulkTemplate($event.target.files)"
                  name="uploadFile"
                  accept=".xlsx"
                />
              </span>
            </div>
          </div>
          <div class="form-footer">
            @if (showtable) {
            <div class="footer-label mb-3 justify-content-center d-flex">
              Total:
              {{ dataSourceDetails_Pass.filteredData.length + dataSourceDetails_fail.filteredData.length }} &nbsp;<span
                class="label-invalid"
                >Invalid: {{ dataSourceDetails_fail.filteredData.length }}</span
              >
              &nbsp;&nbsp;<span class="label-valid">Valid: {{ dataSourceDetails_Pass.filteredData.length }}</span>
            </div>
            }
            <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 d-flex justify-content-end">
              @if (!showtable) {
              <button
                mat-mdc-raised-button
                class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                (click)="previewData()"
                [disabled]="!showPreview"
              >
                Preview
              </button>
              } @if (showtable) {
              <button
                (click)="submitForm()"
                mat-mdc-raised-button
                class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs "
                [disabled]="passdata.length < 1"
              >
                Submit
              </button>
              }
              <button
                (click)="cancelUpload()"
                mat-mdc-raised-button
                class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs "
              >
                Cancel
              </button>
            </div>
          </div>
          <div class="row mt-2">
            @if (!showtable && missingColumns.length > 0) {
            <div class="form-footer">
              <span class="label-invalid">{{ missingColumns.join(', ') }} columns are missing in uploaded file</span>
            </div>
            } @if (!showtable && isDataLarge) {
            <div class="form-text">
              <span class="label-invalid">File should not contain more than 2000 rows</span>
            </div>
            } @if (showtable) {
            <app-maintenance-table-v4
              [TABLE_CONFIG]="TABLE_CONFIG"
              [COLUMNS]="FAIL_COLUMN"
              [SORT_CONFIG]="sortConfig"
              [dataSource]="dataSourceDetails_fail"
              [SCHEMA]="DATA_SCHEMA"
              [BulkUpload]="true"
              [isInvalidTable]="true"
              (filterApplied)="onFilterApplied($event)"
              (filterCleared)="onFilterCleared($event)"
            >
            </app-maintenance-table-v4>
            <app-maintenance-table-v4
              [TABLE_CONFIG]="TABLE_CONFIG"
              [COLUMNS]="PASS_COLUMN"
              [SORT_CONFIG]="sortConfig"
              [dataSource]="dataSourceDetails_Pass"
              [SCHEMA]="DATA_SCHEMA"
              [BulkUpload]="true"
              [isInvalidTable]="false"
            >
            </app-maintenance-table-v4>
            }
          </div>
          @if (showLoader) {
          <div class="stk-table-loader bulk-loader">
            <app-loader> </app-loader>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
